import PropTypes from 'prop-types';
/* eslint-disable no-unused-vars */
import React from 'react';
import withViewportScrollTracking from '../hocs/withViewportScrollTracking';
import { sendAnalyticsEvent, sendDataLayerEvent } from '../../utils/analytics';

export const handleClick = () => {
  sendAnalyticsEvent(
    'Related Content',
    'Click',
    'Most Talked About Stories'
  );
  sendDataLayerEvent('Click', {
    pageModule: 'Most Talked About',
    linkType: 'article'
  });
};

export const Recirculation = () => (
  <></>
);

const decorator = withViewportScrollTracking({
  eventParams() {
    return [
      'Scroll Depth',
      'Scroll',
      'Most Talked About'
    ];
  }
});

export default decorator(Recirculation);

Recirculation.propTypes = {
  primary_category: PropTypes.object.isRequired,
  spotID: PropTypes.string.isRequired
};
